import { NestedHome } from '@habity/types';
import { getCategoryText, getLivingSpace } from '@habity/services';
import { HomeDataBuilder } from './data-builder';
import { propertyFields } from './property-fields';

export const getPropertyData = (home: NestedHome) => {
  if (!home.provider_data || !home.provider_type) return [];

  return new HomeDataBuilder(home)
    .addFields(propertyFields)
    .build();
};

export const getGeneralDescription = (home: NestedHome) => {
  const { living_space, category } = home?.address || {};
  return `${getCategoryText(category)} på ${getLivingSpace(living_space)}`;
};
